module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--8-3bc2e6740db59e934adf0f57c0afe661.jpg";